import { alpha, Button, Card, Typography, useTheme } from "@mui/material";
import { useEmailInvoice } from "../InvoiceStripePayment/useEmailInvoice";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import { useSnackbar } from "@powerdiary/components-library/lib";

interface InvoicePaymentSuccessfulProps {
    invoiceNumber: number;
}

export default function InvoicePaymentSuccessful({ invoiceNumber }: Readonly<InvoicePaymentSuccessfulProps>) {
    const { palette: muiPalette } = useTheme();
    const { mutateAsync, isSendingEmail, sendEmailSuccess } = useEmailInvoice();
    const { enqueueSnackbar } = useSnackbar();

    const emailInvoice = async () => {
        await mutateAsync({ invoiceNumber: invoiceNumber });
        if (sendEmailSuccess) {
            enqueueSnackbar(`Invoice ${invoiceNumber} emailed.`, { variant: "info" });
        }
    };

    return (
        <Card
            sx={{
                height: "185px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                backgroundColor: alpha(muiPalette.primary.main, 0.1),
                border: `1px solid ${alpha(muiPalette.primary.main, 0.1)}`,
            }}
            data-test-id="section_invoice_payment_successful"
        >
            {isSendingEmail && <LoadingOverlay />}
            <Typography variant="heading3">Payment Successful!</Typography>
            <Button variant="contained" onClick={() => void emailInvoice()} data-test-id="button_email_receipt">
                Email Receipt
            </Button>
        </Card>
    );
}
